import * as React from "react"
import { Box, Chip } from "@mui/material";

import { CHART_REASON_COLOR } from "../../constants";
import {BORDER_COLOR, BORDER_STYLE} from "../../../../../@constants";


export default function reasonColumn() {
	return {
		name: 'reason', label: 'Reason',
		options: {
			setCellProps: () => ({ sx: { minWidth: '180px', borderRight: BORDER_STYLE, borderColor: BORDER_COLOR }}),
			customBodyRowRenderLite: (value, row) => <Box sx={{ textAlign: 'center' }}>
				<Chip label={value} sx={{ backgroundColor: row.reasonColor}} />
			</Box>
			
		}
	}
}
